<template>
  <section id="contact" class="contact">
    <div class="resume-content">
      <p class="headline__subtitle animate-headline">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13px" height="13px" viewBox="0 0 13 13"
          fill="currentColor">
          <path fill="currentColor"
            d="M5.6,12.6c-0.5-0.8-0.7-2.4-1.7-3.5c-1-1-2.7-1.2-3.5-1.7C-0.1,7-0.1,6,0.4,5.6c0.8-0.5,2.3-0.6,3.5-1.8 C5,2.8,5.1,1.2,5.6,0.4C6-0.1,7-0.1,7.4,0.4c0.5,0.8,0.7,2.4,1.8,3.5c1.2,1.2,2.6,1.2,3.5,1.7c0.6,0.4,0.6,1.4,0,1.7 C11.8,7.9,10.2,8,9.1,9.1c-1,1-1.2,2.7-1.7,3.5C7,13.1,6,13.1,5.6,12.6z" />
        </svg>
        <span>Contact</span>
      </p>
<div class="resume-items">
      <p class="contact-subtitle">Want to discuss how I can help your team achieve zero critical bugs? Let’s talk!</p>
      <form class="contact-form button-caption" @submit.prevent="handleSubmit">
        <input type="text" placeholder="Your Name" v-model="form.name" required />
        <input type="email" placeholder="Email Address" v-model="form.email" required />
        <textarea placeholder="Your Message" rows="5" v-model="form.message" required></textarea>
        <button type="submit" class="btn-caption">Send Message</button>
      </form>
    </div>
    </div>
  </section>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
      },
    };
  },
  methods: {
    handleSubmit() {
      const serviceID = 'service_iw2f8uo';
      const templateID = 'template_qmis09p'; // ganti dengan Template ID kamu
      const publicKey = 'ifwtqTZCmfNyA947T'; // ganti dengan Public Key dari EmailJS

      emailjs.send(serviceID, templateID, this.form, publicKey)
        .then(() => {
          alert('Message sent!');
          this.form = { name: '', email: '', message: '' };
        })
        .catch((error) => {
          console.error('FAILED...', error);
          alert('Failed to send message.');
        });
    },
  },
};
</script>


<style scoped>

.resume-content {
  /* max-width: 800px; */
  margin-top: 40px;
  margin-bottom: 80px;
  /* margin-right: 40px; */
}

.headline__subtitle {
  display: inline-flex;
  align-items: center;
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: var(--_radius-s);
  border: 1px solid var(--stroke-elements);
  font: normal 700 18px/3.3rem var(--_font-default);
  margin-bottom: 1rem;
}

.headline__subtitle svg {
  margin-right: 8px;
}

.contact-subtitle {
  font-size: 18px;
  padding: 0 1.5rem;
  margin-bottom: 2rem;
  /* color: #475569; */
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* padding: 0 1.5rem; */
  /* margin-top: 40px; */
  /* margin-right: 40px; */
}

.contact-form input,
.contact-form textarea {
  padding: 14px 16px;
  border:  2px solid rgba(176, 176, 176, 0.2);
  border-radius: 12px;
  font-size: 16px;
  font-family: 'Syne', sans-serif;
  transition: border 0.3s, box-shadow 0.3s;
}

.contact-form input:focus,
.contact-form textarea:focus {
  border-color: var(--t-bright--dark);
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.3);
  outline: none;
}

.contact-form button {
  padding: 14px 24px;
  /* background: linear-gradient(135deg, rgba(52, 180, 203, 0.891) 0%, rgba(81, 0, 134, 0.891) 100%); */
  background: transparent;
  color: var(--t-bright--dark);
  font-size: 16px;
    border: none;

  border-radius: var(--_radius-xl);
  /* transform: translateY(-2px) scale(1.05); */
  /* background: rgba(255, 255, 255, 0.08); */
  box-shadow: 0 0 16px rgba(239, 29, 242, 0.725);
  /* backdrop-filter: blur(10px); */
  cursor: pointer;
  /* transition: transform 0.2s ease;
  font-family:  'Syne', sans-serif; */
}

.contact-form button:hover {
  transform: scale(1.03);
}
</style>
